import React from "react";
import { Link } from "gatsby";
import LastImage from "react-last-image";
import {
  mdiPlayCircle,
  mdiHelpCircle,
  mdiAccountCircle,
  mdiFile
} from "@mdi/js";

import { Box } from "../globals";
import { H6 } from "../headings";
import Icon from "../icon";
import Text from "../text";

const TallGridCard = ({
  width,
  height,
  bg,
  children,
  color,
  icon,
  label,
  image,
  link,
  fontSize,
  className,
  ...rest
}) => (
  <Box
    as={link ? Link : "div"}
    to={link && link}
    css={`
      position: relative;
      display: flex;
      flex-direction: column;
      width: 25%;
      font-size: 25vw;
      @media (max-width: 80em) {
        width: 50%;
        font-size: 50vw;
      }
      &.haslink {
        &::after {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
          content: "";
          box-shadow: inset 6px 6px 6px 0 rgba(255, 255, 255, 0.5),
            inset -6px -6px 6px 0 rgba(0, 0, 0, 0.5);
        }
      }
      &::before {
        content: "";
        display: block;
        padding-top: 200%;
        float: left;
      }
    `}
    className={className + (link && " haslink")}
    bg={"brand." + color}
    {...rest}
  >
    <div
      css={`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height: 100%;
        width: 100%;
        user-select: none;
      `}
    >
      {image && (
        <LastImage
          lazy={false}
          images={[
            {
              url: image.url,
              height: image.dimensions.height,
              width: image.dimensions.width
            }
          ]}
          style={{ height: "100%" }}
          placeholder={<></>}
          alt={image.alt}
        />
      )}
    </div>
    <div
      css={`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        padding: 0.1em;
      `}
    >
      {icon && (
        <Icon
          symbol={
            icon === "Play"
              ? mdiPlayCircle
              : icon === "Question"
              ? mdiHelpCircle
              : icon === "File"
              ? mdiFile
              : mdiAccountCircle
          }
          color="white"
          size={3}
          css={`
            font-size: 0.11em;
            width: 1em !important;
            height: 1em !important;
            ${icon === "None" && `display: none`};
          `}
        />
      )}
      {label && (
        <H6
          my={3}
          children={label}
          css={`
            position: relative;
            font-size: 0.035em !important;
            color: ${props => props.theme.colors.text.reverse};
            &::after {
              content: "";
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              border-bottom: 1px solid
                ${props => props.theme.colors.text.reverse};
            }
          `}
        />
      )}
      <Text
        children={children}
        as="h1"
        css={`
          font-size: ${fontSize !== ""
            ? fontSize === "Large"
              ? "0.2261em !important"
              : fontSize === "Medium"
              ? "0.14195em !important"
              : "0.0935em !important"
            : "0.0935em !important"};
          line-height: 1 !important;
          color: ${props => props.theme.colors.text.reverse};
          p {
            margin: 0;
          }
        `}
      />
    </div>
  </Box>
);

export default TallGridCard;
